import { FC, Key } from 'react'
import { useTranslation } from 'react-i18next'
import { CompressOutlined, ExpandOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

import { ExpandableRowData } from '@types'

import { StyledButton } from '../StyledComponents'

interface CollapseExpandProps {
  handleSetRowData: (expandedKeys: readonly Key[]) => void
  preparedData: ExpandableRowData[]
}

const CollapseExpand: FC<CollapseExpandProps> = ({ handleSetRowData, preparedData }) => {
  const { t } = useTranslation()
  const handleExpand = () => {
    handleSetRowData(preparedData?.map(({ key }) => key))
  }

  const handleCollapse = () => {
    handleSetRowData([])
  }
  return (
    <div style={{ display: 'flex', flexWrap: 'nowrap', gap: '0.5rem' }}>
      <Tooltip placement="bottomLeft" title={t('colapse_expand.collapse_all')}>
        <StyledButton className="inline option" onClick={handleCollapse}>
          <CompressOutlined className="option-button" />
        </StyledButton>
      </Tooltip>
      <Tooltip placement="bottomLeft" title={t('colapse_expand.expand_all')}>
        <StyledButton className="inline option" onClick={handleExpand}>
          <ExpandOutlined className="option-button" />
        </StyledButton>
      </Tooltip>
    </div>
  )
}

export default CollapseExpand
